import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {FormCellType} from '@core/interfaces/engin/maintenance-planning/form-visualization';

@Component({
    selector: 'ngx-form-cell-header',
    templateUrl: './cell-header.component.html',
    styleUrls: ['./cell-header.component.scss', '../base/form-field-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellHeaderComponent {
    @Input() fieldLabel: string;
    @Input() required: boolean;
    @Input() countOfDeficiency: number = 0;
    @Input() cellType: FormCellType;
    @Output() addDeficiency = new EventEmitter<void>();
    @Output() onLeadIconClick = new EventEmitter<void>();

    FormCellType = FormCellType;

    /**
     * Emits event when the add deficiency button is clicked for a specific field of the form.
     */
    onAddDeficiencyClicked(): void {
        this.addDeficiency.emit();
    }
}
